import classNames from 'classnames';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { WARNING_BASE_LAND, WARNING_BASE_MARINE } from 'components/navigation/config.js';
import { useRef } from 'react';
import { WarningEventType } from 'redux-state/weather-warnings/types-events.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { PanelBodyMarineList } from '../../utilities/weather-warnings/panel-body-marine-list.js';
import { PanelBodyLandItem } from './panel-body-land-item.js';
import { getPanelBodyMarineList } from './panel-body-marine-list-container.js';
import { GetTransitionHeight } from './utils/get-transition-height.js';

interface IWarningContentProps {
  warnings?: IWarning[];
}

interface IEventType {
  detailDisplay: IWarning[];
  listDisplay: IWarning[];
}

const isLastItem = (index: number, arr: unknown[]) => {
  if (index === arr.length - 1) {
    return true;
  }
  return false;
};

/** Seperate warnings into  */
const partitionWarningsByType = (warnings: IWarning[]): IEventType => {
  const PanelBodyListType: `${WarningEventType}`[] = [
    WarningEventType.WIND_ADVISORY,
    WarningEventType.MARINE_GALE,
    WarningEventType.MARINE_STORM,
  ];
  const regions: IEventType = {
    detailDisplay: [],
    listDisplay: [],
  };
  for (const warning of warnings) {
    const warnEvent = warning.eventType;
    if (PanelBodyListType.indexOf(warnEvent) >= 0) {
      // may ned to divide these by marine in the future (warning.type)
      regions.listDisplay.push(warning);
    } else {
      regions.detailDisplay.push(warning);
    }
  }
  return regions;
};

export function WarningContent({ warnings }: IWarningContentProps) {
  const anim = useRef<HTMLDivElement>(null);
  const height = anim.current?.scrollHeight;
  if (height) {
    anim.current?.style.setProperty('--max-height', height + 'px');
  }

  if (warnings?.length) {
    const warnArr = partitionWarningsByType(warnings);
    const landWarnArr = warnArr.detailDisplay;
    const marineWarnArr = getPanelBodyMarineList({ warnings: warnArr.listDisplay });

    return (
      <GetTransitionHeight className="WeatherWarning-body u-pT-0">
        <ul data-module="warning-panel-content" className="ArticleList ArticleList--withBorders">
          {landWarnArr?.map((warning, index) => {
            return (
              <PanelBodyLandItem
                warning={warning}
                key={index}
                isLast={isLastItem(index, landWarnArr)}
                classes={index !== landWarnArr.length - 1 ? 'u-pB-sm' : ''}
              />
            );
          })}
          {marineWarnArr.map((wa, index) => {
            return (
              <li
                key={wa.key}
                className={classNames('ArticleList-item', { 'u-bB-0': isLastItem(index, marineWarnArr) })}
              >
                <div className="Grid Grid--withGutter">
                  <div className="Grid-cell u-width1of1">
                    <PanelBodyMarineList warnings={wa.warnArr} />
                  </div>
                </div>
              </li>
            );
          })}
          <LinkRef
            link={{
              url: warnArr.detailDisplay.length ? WARNING_BASE_LAND : WARNING_BASE_MARINE,
              label: 'View all severe weather',
            }}
          />
        </ul>
      </GetTransitionHeight>
    );
  }
  return null;
}
